import { useQuery } from '@tanstack/react-query';
import { createContext, useContext, type ReactNode } from 'react';
import { ApiError, api, type Me } from './api';

const AuthCtx = createContext<{ me: Me | null; loading: boolean }>({ me: null, loading: true });

export function AuthProvider({ children }: { children: ReactNode }) {
  const { data, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<Me>('/auth/me'),
    retry: (count, err) => {
      // 401 é resposta válida ("não logado"), não erro de rede: não insistir.
      if (err instanceof ApiError && (err.status === 401 || err.status === 403)) return false;
      return count < 2;
    },
    staleTime: 5 * 60_000,
  });

  return (
    <AuthCtx.Provider value={{ me: data ?? null, loading: isLoading }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
